// extracted by mini-css-extract-plugin
module.exports = {"headlineContainer":"HeadlineImage_headlineContainer__3jQjl","imageContainer":"HeadlineImage_imageContainer__wWbYR"};